<div>
    <app-side-navigation [adminUser]="true" *ngIf="!hideSidebar"></app-side-navigation>
    <div class="main-content-body">
        <div class="page-content">
            <nz-content>
                <router-outlet></router-outlet>
            </nz-content>
        </div>
    </div>
</div>